﻿import { IEditor } from "../interface/editor";
import { ValidatorError } from "../types/validator-error";
import { ValidatorFn } from "../types/validator-fn";
import { ValidatorParam } from "../interface/validator-param";
import { isValidatorDisabled } from "./is-validator-disabled";


export interface regularValidatorParam extends ValidatorParam {
    regExp: RegExp;
}

export function regularValidator(param: regularValidatorParam): ValidatorFn {

    return (editor: IEditor): ValidatorError | null => {
        if (isValidatorDisabled(param, editor)) {
            return null;
        }

        let message='Validate Failed';
        if(param.message) {
            message= param.message;
        }

        if (editor.value !== undefined && editor.value != null && editor.value !== '') {
            const newReg = cloneRegex(param.regExp);
            if (newReg.test(String(editor.value))) {
                return null;
            } else {
                return { message: message};
            }
        } else {
            return null;
        }
    };
}

function cloneRegex(input: RegExp) {
    const pattern = input.source;
    return new RegExp(pattern, input.flags);
}

